import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class PerLoader extends Loader {}

export const perLoader = new PerLoader({
  service: SERVICES.per
})
